import * as React from "react"

import { App } from "./app"
import { Assert } from "./PADebug"
import { BuildPartGW } from "./BuildPartGW"


///////////////   BuildPartSet  ////////////////

// BuildPartSet represents a selection of build parts, with amounts on each of them.
export class BuildPartSet {

    constructor() {
        this.m_buildParts = new Array<{ id: string, amount: number }>()
    }

    // InitiateFromBeta utilizes the meta data of a saved project (or buildpart) to fill the buildparts array with content
    public InitiateFromMeta(beta: string) {
        var startPosition = -1
        var endPosition = -1
        var i = 6;

        for (; i < beta.length - 2; i++) {
            if ((beta.charAt(i) == '#') && (beta.charAt(i + 1) == 'B') && (beta.charAt(i + 2) == '<')) {
                // Start position will not be overridden by any accidentally or intentionally similar series of 
                // letters within content, as only the first and expected occurance will take effect
                if (startPosition == -1) {
                    startPosition = i + 3
                }
            }

            // Similarily the end position won't be affected by identical letters within the content, as the last
            // and expected occurance will always override any previous accidental ones within the content.
            if ((beta.charAt(i) == '>') && (beta.charAt(i + 1) == 'B') && (beta.charAt(i + 2) == '#')) {
                endPosition = i
            }
        }

        if ((startPosition > 0) && (endPosition > 0)) {
            var BPData = beta.substr(startPosition, (endPosition - startPosition))

            try {
                this.m_buildParts = JSON.parse(BPData)
            }

            catch (e) {
                Assert(false, "BuildPartSet.InitiateFromBeta - Parsing meta data into build parts has failed!")
                alert("BPData:" + BPData)
            }
        }
        else {
            Assert(false, "BuildPartSet.InitiateFromBeta - Beta could not be read because the meta start and end positions for build part data reading weren't located properly!")
            Assert(false, "BuildPartSet.InitiateFromBeta - beta:" + beta + " startpos:" + startPosition.toString() + " endPos:" + endPosition.toString() )
        }
    }

    // GetAsMetaString produces a string that can be added into the meta string and which later can be read
    // as data for a BuildPartSet by using InitiateFromBeta on that resulting meta data.
    public GetAsMetaString() {
        return "#B<" + JSON.stringify(this.m_buildParts) + ">B#"
    }

    // Access - buildparts array
    public GetBuildParts() {
        return this.m_buildParts
    }

    // Access to a certain amount value by the use of an ID value 
    public GetAmount(id: string) {
        for (var i = 0; i < this.m_buildParts.length; i++) {
            if (this.m_buildParts[i].id == id) {
                return this.m_buildParts[i].amount
            }
        }

        return -1 // This build part was not within the buildpartset
    }

    // Reads the array of build parts within selection as content for this build part set
    public InitiateFromBuildParts(bParts: Array<BuildPartGW>) {
        this.m_buildParts = new Array<{ id: string, amount: number }>()
        for (var i = 0; i < bParts.length; i++) {
            this.m_buildParts.push({ id: bParts[i].GetId(), amount: bParts[i].GetAmount() })
        }
    }

    private m_buildParts: Array<{ id: string, amount : number }>
}




// WEBPACK FOOTER //
// ./client/view/BuildPartSet.tsx